export const CustomTexts = {
    privacyPolicy: `
    <h4 class='title'>
    <strong>Privacy Policy</strong>
</h4>
<u>
    <strong>Our Commitment to Information Privacy</strong>
</u>
<p>The Cancer Support Community® non-profit corporation (Cancer Support Community® together with any and all of its members,
    directors, and affiliated entities, which are referred to collectively herein as "CSC") is committed to protecting the
    privacy and security of your visits to My Tracker, a proprietary tool of the MyCareReport program. This page explains
    our online information collection and utilization practices. If you have questions about this Privacy Policy, please
    contact us at npower@cancersupportcommunity.org or call us at: 646-600-7567.</p>
<u>
    <strong>Information Collected</strong>
</u>
<p>The types of information collected by My Tracker and how that information is used are described below.</p>
<p>
    <strong>Personal Information:</strong> To sign you up and authorize you to access the registered-only section of My Tracker,
    My Tracker collects some information that can be directly associated with you and any person for whom you are creating
    a profile. This information includes name, date of birth, cancer type, and primary clinic where you receive treatment.
    This information is used to improve your experience on My Tracker, by allowing us to communicate your side effects back
    to your health care team and provide local resources based on where you receive treatment.</p>
<p>
    <strong>Information used for Research:</strong> Once you have become a participant in My Tracker, you will be able to take surveys
    about your side effects, your treatment-related distress, and your thoughts on MyCareReport.</p>
<p>This information will be used for research purposes to help identify the emotional, social, and financial impacts of cancer
    and immunotherapy, as well as to help us evaluate MyCareReport. The aggregated findings from this initiative may
    be published in scientific journals or might be presented at professional meetings. Your name or any other identifying
    information that could be linked to you will not be used.</p>
<p>
    <strong>Standard Web Server Traffic Pattern Information:</strong> General traffic, site usage, and length-of-stay information
    is collected and stored in log files throughout both the public and the registered-only sections of My Tracker. This
    type of information is not shared outside of the CSC team, and then only in summary so any personal information will
    remain anonymous and unidentifiable.</p>
<u>
    <strong>Opting Out</strong>
</u>
<p>By registering as a participant in My Tracker, you have granted permission to use your Personal Information to send you emails
    ("opt-in"). If you have received an email from My Tracker, the records indicate that you are a registered participant
    or have asked to receive such information.</p>
<p>Because My Tracker respects your time and attention, every effort is made to control the frequency of My Tracker emails.
    You may remove the permission you have given to use your Personal Information to send you emails ("opt-out") by following
    the opt-out links at the end of any emails sent to you.</p>
<p>If you believe you have received unwanted, unsolicited email from My Tracker sent via the website or purporting to be sent
    via My Tracker, please forward a copy of that email to npower@cancersupportcommunity.org.</p>
<u>
    <strong>Privacy and Sharing of Your Personal Information</strong>
</u>
<p>It is our policy not to make Personal Information available to anyone other than the CSC team involved in My Tracker and
    your health care team. We will never share, sell or rent Personal Information without your prior permission or unless
    required by law. Personal Information will only be made available to staff managing this information for purposes of
    contacting you or sending you emails based on your request for information, or to assist your health care team in managing
    your care.</p>
<u>
    <strong>Security</strong>
</u>
<p>My Tracker maintains a variety of physical, electronic, and procedural safeguards to protect your Personal Information. As
    mentioned above, it is My Tracker’s policy to restrict access to Personal Information to the CSC team and your health
    care team.</p>
<u>
    <strong>Use of Cookies</strong>
</u>
<p>Most modern websites use cookies which are small files that are sent to your Web browser and stored on your computer's hard
    drive to speed up your access to the information you wish to see, but they do not contain any personal information. The
    majority of Web browsers accept cookies, but the "help" menu on your browser should give you options for preventing,
    accepting, or receiving notice of new cookies. However, please be aware that if you block cookies, some website functionality
    may be lost.</p>
<u>
    <strong>External Website Links</strong>
</u>
<p>My Tracker's privacy policy applies only to My Tracker. The My Tracker website contains links to other sites, including sites
    that have a special relationship with My Tracker. My Tracker does not disclose personably identifiable information to
    those operating linked sites, and My Tracker is not responsible for their privacy practices. Links to other sites do
    not imply an endorsement of the materials or policies on those websites. You should read the privacy policies of each
    site you visit to determine what information that site may be collecting about you.</p>
<u>
    <strong>Use of Web Beacons</strong>
</u>
<p>When My Tracker sends emails to participants in My Tracker, it may include a Web Beacon to allow My Tracker to determine
    the number of users who open My Tracker emails. When you click on a link in an email that My Tracker has sent to you,
    it may record this individual response to allow My Tracker to customize offerings to you.</p>
<p>Web Beacons collect only limited information, such as a cookie identifier, time and date of a page being viewed, and a description
    of the page on which the Web Beacon resides (the URL). Web Beacons can be refused when delivered via email. If you do
    not wish to receive Web Beacons via email, you will need to disable HTML images or refuse HTML (select Text only) emails
    via your email software.</p>
<u>
    <strong>Policy Updates</strong>
</u>
<p>This Privacy Policy applies to your use of the My Tracker domains and all associated services including, but not limited
    to, email received from My Tracker or any of its computer systems, databases or networks connected to My Tracker and
    all of its sub-domains, and content embedded on other websites. My Tracker reserves the right to update this policy at
    any time. If a material change is made to the policy, those changes will be clearly posted on My Tracker.</p>
    `,

    termsConditions: `
    <h4 class="title">Terms and Conditions</h4>
    <u>
        <strong>General Purpose and Acceptance of Terms and Conditions</strong>
    </u>
    <ol>
        <li>
            <p>
                <strong>General.</strong> Use of the My Tracker Website (the "Website") and the services associated with the Website
                (the "Services") is governed by the following terms and conditions herein (the "Terms and Conditions") and a
                privacy policy (the "Privacy Policy"), both of which you must read before using the Website and the Services.
                All pages within the Website are owned and operated by the Cancer Support Community® non-profit corporation (Cancer
                Support Community® together with any and all of its members, directors, and affiliated entities, which are referred
                to collectively herein as "CSC").
            </p>
        </li>
        <li>
            <p>
                <strong>Purpose.</strong> The purpose of the Website is to allow persons to access certain information on the Website's
                database, and take surveys to assist in their care and the MyCareReport program. The information provided
                by the registrant, during registration, is maintained in a secured database and will never be shared without
                the registrant's expressed consent. However, information that does not identify any individual registrant may
                be used in published research.
            </p>
        </li>
        <li>
            <p>
                <strong>Acceptance of Terms and Conditions.</strong> By using the Website, you represent, accept, and agree that you
                have read all of the Terms and Conditions and the Privacy Policy, understand them, and that you agree to and
                have the legal capacity to be bound by them. These Terms and Conditions constitute a legal agreement between
                you and CSC. CSC reserves the right to modify these Terms and Conditions at any time in its sole discretion,
                and without prior notice, by posting amended terms on this website. We encourage you to review the website Terms
                and Conditions periodically for any updates or changes. If you do not agree to be bound by the Terms and Conditions
                and the Privacy Policy, you may not use the Website.
            </p>
        </li>
    </ol>
    <u>
        <strong>Ownership</strong>
    </u>
    <p>All CSC-generated content available at the Website, including without limitation, any information, software, photographs,
        images, video, audio, graphics, or text on the Website ("Content"), and all patent, copyright, trademark, trade dress,
        domain name, trade secret, and other proprietary rights therein are the sole property of CSC or used by CSC with the
        permission of the owner of such content. You agree to abide by all applicable intellectual property laws and any additional
        restrictions set forth on the Website in relation to the Content.</p>
    <u>
        <strong>Use of the Website</strong>
    </u>
    <ol>
        <li>
            <p>
                <strong>Legal Capacity.</strong> Persons who are eighteen (18) years of age or older and legally competent may register
                on behalf of themselves or another person who has given his/her permission to be registered. Once registered,
                the legally competent person who engaged in the registration process may use the My Tracker resources. If you
                don 't meet the criteria set forth above or if you are not competent to form legally binding agreements, you
                may NOT use this Website.
            </p>
        </li>
        <li>
            <p>
                <strong>True, Accurate, and Complete Information.</strong>
                If you register to use the Website, you agree to provide true, accurate, and complete registration information.
            </p>
        </li>
        <li>
            <p>
                <strong>Lawful Use.</strong> You agree to use the Website for lawful purposes only. You shall comply with all federal,
                state, and local laws applicable to the use of this Website and shall not use the Website to engage in any prohibited
                conduct.
            </p>
            <p> Prohibited conduct, broadly stated, is any conduct that (a) is unlawful, infringing, tortious, fraudulent, abusive,
                harassing, or otherwise harmful to CSC or any other party or property; (b) violates another party's intellectual
                property, privacy, or other rights; or (c) otherwise interferes with the operation, use, or enjoyment of any
                service, system, or other property.
            </p>
            <p> Without limiting the generality of the foregoing, any information provided by you in connection with use of the Website
                shall not: (a) be false, fraudulent, inaccurate, or misleading; (b) be obscene or indecent; (c) contain any viruses,
                Trojan horses, worms, time bombs, spiders, or other computer programming routines that are intended to damage,
                detrimentally interfere with, surreptitiously intercept, or expropriate any system, data, or personal information;
                (d) infringe on any of CSC 's or other third party's copyright, patent, trademark, trade secret, or other proprietary
                rights or rights of publicity or privacy; (e) be defamatory, libelous, unlawfully threatening or harassing; and
                (f) create liability for CSC or cause us to lose the services of our Internet service providers or other suppliers.</p>
            <p>
                You may not take any action that imposes an unreasonable burden upon the infrastructure used to support the Website, including
                but not limited to unsolicited email, also called spam.</p>
        </li>
        <li>
            <p>
                <strong>Website for Allowable Activities (defined herein).</strong> The Website is for the use of registered users only.
                Specifically, individuals can use the Website to register and update a registration and, once registered, to
                use the Website’s resources (the "Allowable Activities").</p>
            <p> The Website cannot be used in connection with any other endeavor outside of the Allowable Activities, including,
                but not limited to blogging. Specifically, users shall not disclose, post, publish, display, or transmit any
                of the Website content, without the written consent of CSC.</p>
        </li>
        <li>
            <p>
                <strong>No Unauthorized Use.</strong> You may not attempt to gain unauthorized access to this Website or any services,
                other accounts, or computer systems or networks connected to any server or to any of the Services, through hacking,
                password mining, or any other means.
            </p>
        </li>
    </ol>
    <u>
        <strong>User Conduct and Responsibility</strong>
    </u>
    <ol>
        <li>
            <p>
                <strong>Security.</strong> You are solely responsible for the security of your password and your account, and are fully
                responsible for all activities that occur under your password or account with or without your knowledge. If you
                knowingly provide your login and password information to another person, outside of a designated member of your
                care team (such as a caregiver), your account privileges may be suspended temporarily or terminated. You agree
                to immediately notify the My Tracker Coordinator of any unauthorized use of your password or account or any other
                breach of security. CSC will not be liable for any loss or damage arising from your failure to comply with this
                section.
            </p>
            <p>Certain portions of the Website and information contained on the Website may be accessible only to registered users
                or to affiliates, service providers, or other business partners of CSC, or may otherwise be password restricted.
                You agree not to (i) gain or attempt to gain unauthorized access to such portions of the Website or to information
                contained in such sections of the Website; (ii) obtain or attempt to obtain confidential, proprietary, and/or
                personal information stored on the Website; (3) distribute passwords to unregistered or unauthorized users; or
                (iv) make any unauthorized use of the Website or information accessible on the Website.</p>
        </li>
        <li>
            <p>
                <strong>User Submitted Content.</strong> You acknowledge and agree that, upon creation of a profile on the Website and
                registration, your submitted content (each submission individually, and all submissions, collectively, referred
                to herein as the "User Submission") may be available to members of your health care team. Notwithstanding the
                foregoing, however, CSC makes no representation or guaranty that your profile information will be reviewed.</p>
            <p>CSC is not in any way associated with or responsible for content posted on or transmitted to the Website by users,
                including, but not limited to, User Submissions. CSC has the right, but not the obligation, to monitor and verify
                content posted on or transmitted to the Website for any reason, and reserves the right to remove anything that
                is, in its sole discretion, unacceptable, inappropriate, or not in compliance with these Terms and Conditions,
                to disclose data to law enforcement agencies or authorities who may investigate reports of misuse or abuse of
                this Website, and to terminate any User 's access to the Website at any time, without prior notice.</p>
            <p>Each user acknowledges and agrees that CSC is not required to edit or review any information or content posted, submitted,
                or otherwise transmitted by users. However, CSC reserves the right, in its sole discretion, to verify and correct
                any errors, inaccuracies, or omissions in any portion of the Website or content posted thereon or submitted or
                otherwise transmitted thereto, and all such content may be subject to CSC approval. CSC reserves the right, at
                any time, for any reason, to reject, suspend, cancel, or remove content, and neither CSC, nor its employees,
                consultants, or other agents will have any liability for taking such actions.</p>
            <p>You are responsible for any content you post, publish, display, or otherwise transmit to the Website. You agree not
                to transmit or otherwise make available on the Website any personal information of any individual or any material
                protected by copyright, trademark, publicity, privacy, or other proprietary right without the express permission
                of such individual or the owner of such rights, respectively.</p>
            <p>The burden of determining that transmission of the information is permissible, or that the material is not protected
                by such rights, is on you, the user. You shall be solely liable for and shall indemnify and hold CSC harmless
                for any damages resulting from any infringement of copyrights, trademarks, proprietary rights, violation of privacy
                or publicity rights, or any other harm resulting from your submissions to, or transmission of information from,
                the Website.</p>
            <p>
                By submitting material to any area of the Website, you expressly grant to CSC the royalty-free, perpetual, irrevocable, non-exclusive
                right and license to use, reproduce, modify, adapt, publish, translate, and distribute such material (in whole
                or in part) worldwide, in accordance with the Privacy Policy.</p>
            <p>You further understand and acknowledge that you may be exposed to User Submissions that are inaccurate or otherwise
                objectionable, and you agree to waive and hereby do waive, any legal or equitable rights or remedies you have
                or may have against CSC with respect thereto, and agree to indemnify and hold CSC harmless to the fullest extent
                allowed by law regarding all matters related to your use of the Website, whether as a registered user in submitting
                User Submissions and/or creating a profile, or as a representative of an institution using the Website for informational
                and educational purposes.</p>
            <p>Users may report abuses of the Website to the My Tracker Coordinator with sufficient detail identifying the abusive
                conduct or content, so that CSC may determine, in its sole discretion, whether to take action with respect to
                such alleged abuse.
            </p>
            <p>You are solely responsible for and will exercise caution, discretion, common sense, and judgment in using and accessing
                the Website and all content contained therein. You are solely responsible for any equipment necessary to access
                and use the Website.</p>
        </li>
        <li>
            <p>
                <strong>Cooperation.</strong> You agree to cooperate fully with CSC to investigate any suspected or actual activity that
                is in breach of these Terms and Conditions.
            </p>
        </li>
        <li>
            <p>
                <strong> Risk of Using the Website and the Internet.</strong> You assume total responsibility and risk for your use of
                the Website and the Internet. You acknowledge and agree that any uploads or transmission you make to, from, or
                through the Website may be intercepted and used by an unauthorized third party and that all of the risk associated
                with these activities is solely yours.
            </p>
        </li>
        <li>
            <p>
                <strong>Links to Other Websites.</strong> The Website may contain links to other Websites that are not under the control
                of CSC. CSC is not responsible for the contents of any linked Website or any link contained in a linked Website,
                or any changes or updates to such Websites. The inclusion of any link does not imply endorsement by CSC. It is
                up to you to take precautions to ensure that whatever you select for your use is free of viruses, worms, Trojan
                horses, and other items of a destructive nature.</p>
        </li>
    </ol>
    <u>
        <strong>Information Contained on Website</strong>
    </u>
    <p> In the course of using the Website or Services, users may provide information about themselves, which may be communicated
        to their health care team (see the Privacy Policy to learn more about information collected on the Website). You understand
        that by posting materials on the Website or otherwise providing materials to us, you are agreeing to allow us to aggregate
        your anonymized data for use in research.</p>
    <p> You understand that all information privately transmitted through the Website is the sole responsibility of the person from
        which such content originated and that CSC will not be liable for any errors or omissions in any content.</p>
    <u>
        <strong>Disclaimer of Medical Advice</strong>
    </u>
    <p>You understand and acknowledge that all users are responsible for their own medical care, treatment, and oversight. All of
        the Content provided on the Website is for informational purposes only and DOES NOT CONSTITUTE THE PROVIDING OF MEDICAL
        ADVICE and is not intended to be a substitute for independent professional medical judgment, advice, diagnosis, or treatment.</p>
    <p>
        The Content is not intended to establish a standard of care to be followed by a user of the Website. You understand and acknowledge
        that you should always seek the advice of your physician or other qualified health provider with any questions or concerns
        you may have regarding your health or before making any changes to your treatment routine. You also understand and acknowledge
        that you should never disregard or delay seeking medical advice relating to treatment or standard of care because of
        information contained in or transmitted through the Website.</p>
    <u>
        <strong>Disclaimer of Warranties</strong>
    </u>
    <p>The website and the content made available on the website are provided on an "as is" and "as available" basis. CSC does not
        make any express or implied warranties, representations, or endorsements whatsoever (including, but not limited to, warranties
        of title or non-infringement, or the implied warranties of merchantability or fitness for a particular purpose) with
        regard to the website, the content, any advice, or services provided through the website or on the internet generally.</p>
    <p>Some states may not permit the disclaimer of implied warranties, so the foregoing disclaimer may not apply to you. CSC does
        not warrant that the website will be uninterrupted or error-free or that defects in the website will be corrected, that
        any information contained on or transmitted through the website is complete or accurate, that user or other information
        will be completely secure from unauthorized access or disclosure, or that any information is free of viruses or other
        rogue programming.</p>
    <u>
        <strong>Limitation of liability</strong>
    </u>
    <p>Under no circumstances shall CSC or any of its partners, contributors, agents, employees, or any other party involved in
        creating, producing, or distributing the website or providing content, advice, products ,or services through the website
        be liable for any direct, indirect, incidental, special, or consequential damages for loss of profits, goodwill, use,
        data, or other intangible losses (even if we have been advised of the possibility of such damages) that result from:
        (i) the use of or inability to use the website; (ii) any inaccuracies, errors, omissions, or lack of authenticity in
        the content; (iii) use of the content; (iv) the cost of procuring substitute merchandise, advice, and services resulting
        from use of the website; (v) any loss, misuse, or unauthorized access to or alteration of information or materials transmitted
        to or contained on the website; (vi) statements, advice, warranties, guarantees, or conduct of CSC or any third party
        on the website, or (vii) any other matter relating to the use of the website.</p>
    <p>You hereby acknowledge that this paragraph shall apply to all content, advice, merchandise, and services available through
        the website. Because some states may not allow the exclusion or limitation of liability for consequential or incidental
        damages, in such states liability is limited to the least amount permitted by law. The limitations of liability provided
        in this agreement inure to the benefit of CSC and its respective affiliates, partners, contributors, officers, directors,
        employees, assigns, attorneys, and agents.</p>
    <u>
        <strong>Indemnification</strong>
    </u>
    <p>You agree to indemnify and otherwise hold harmless CSC, its officers, employees, agents, subsidiaries, affiliates, and other
        partners from any and all liability, including any and all direct, indirect, incidental, special, consequential, or exemplary
        damages, and any and all costs and/or expenses (including reasonable attorneys ' fees) resulting from (i) your use of
        the Website, including, but not limited to, your access to, submission of, or distribution of, information to or from
        the Website; (ii) any misuse, unauthorized access to, disclosure, alteration, or destruction of the Website, information
        contained in the Website, and/or your communications with or through the Website, or (iii) any other matter relating
        to the Website.</p>
    <p>You understand and agree that CSC may disclose information if required to do so by law or in the good faith belief that such
        disclosure is reasonably necessary to comply with legal process, enforce these Terms and Conditions, or protect the rights,
        property, or safety of CSC, users of the Website, and the public.</p>
    <u>
        <strong>Copyright and Copyright Agent</strong>
    </u>
    <p>The Website and the compilation (meaning selection, composition, and arrangement) of all of the content on the Website is
        the exclusive property of CSC and protected by U.S. and international copyright law. CSC reserves the right to remove
        any content, from any source, at any time, for any reason (including, but not limited to, claims or allegations made
        by third parties relating to such content).</p>
    <p>Users of the Website agree to not take any action with respect to content of the Website that would violate the intellectual
        property rights of CSC or the individual rights of other users. Content contained on the Website may not be modified,
        copied, distributed, framed, republished, downloaded, displayed, or sold in any form or by any means, in whole or in
        part, without the prior written consent of CSC or, in the case of user-submitted content, any other appropriate party
        or parties.</p>
    <p>It is the sole responsibility of the user to secure all necessary rights and permissions before downloading, reproducing,
        modifying, distributing, or otherwise using user-submitted content.</p>
    <p>CSC respects the intellectual property of others and asks that users do the same. If a user or any other party feels that
        its work has been copied in a way that constitutes copyright infringement, that person should provide CSC 's designated
        Copyright Agent with the following information:</p>
    <ol class="bold-list">
        <li>A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is
            allegedly infringed;</li>
        <li>Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single
            online Website are covered by a single notification, a representative list of such works at that Website;</li>
        <li>Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that
            is to be removed or access to which is to be disabled, and information reasonably sufficient to permit the service
            provider to locate the material;</li>
        <li>Information reasonably sufficient to permit the service provider to contact the complaining party, such as an address,
            telephone number, and, if available, an electronic mail address at which the complaining party may be contacted;</li>
        <li>A statement that the complaining party has a good faith belief that use of the material in the manner complained of is
            not authorized by the copyright owner, its agent, or the law; and</li>
        <li>A statement that the information in the notification is accurate, and under penalty of perjury, that the complaining
            party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.</li>
    </ol>
    <p>Users may contact CSC 's designated Copyright Agent for notice of claims of infringement on this Website as follows:</p>
    Cancer Support Community
    <br> Jeff Travers
    <br> Executive Vice President, Finance and Administration
    <br> 734 15th Street NW | Suite 300
    <br> Washington, DC 20005
    <br> T: 202-659-9709
    <br> jtravers@cancersupportcommunity.org
    <br>
    <br>
    <u>
        <strong>Trademarks</strong>
    </u>
    <p>The name CSC, the CSC logo, and other CSC logos and names are trademarks of CSC. You agree not to display or use these trademarks
        in any manner without CSC 's prior, written permission.</p>
    <u>
        <strong>Users Outside the United States</strong>
    </u>
    <p>CSC makes no claims that information on the Website is appropriate or may be downloaded outside of the United States. Access
        to the Website may not be legal in certain countries or for certain persons. If you access the Website from outside of
        the United States, you do so at your own risk and are responsible for compliance with the laws of your jurisdiction regarding
        online conduct and acceptable content. User personal information ( "Information") that is submitted to this Website will
        be collected, processed, stored, disclosed, and disposed of in accordance with applicable U.S. law and our Privacy Policy.</p>
    <p>If you are a non-U.S. user, you acknowledge and agree that CSC may collect and use your Information and disclose it to other
        entities outside your resident jurisdiction. In addition, such Information may be stored on servers located outside your
        resident jurisdiction. U.S. law may not provide the degree of protection for Information that is available in other countries.
        By providing us with your Information, you acknowledge that you consent to the transfer of such Information outside your
        resident jurisdiction as detailed in our Privacy Policy. If you do not consent to such transfer, you may not use this
        Website.</p>
    <u>
        <strong>General Practices Regarding Use and Storage</strong>
    </u>
    <p>You agree that CSC has no responsibility or liability for the deletion or failure to store any messages and other communications
        or other Content maintained or transmitted by the Website. You acknowledge that CSC reserves the right to log off accounts
        that are inactive for an extended period of time. You further acknowledge that CSC reserves the right to modify these
        general practices and limits from time to time.</p>
    <u>
        <strong>Privacy</strong>
    </u>
    <p>You agree that you have read and understand the terms of the Privacy Policy. This policy governs the collection, use, and
        sharing of personal and non-personal information from you when using the Website.</p>
    <u>
        <strong>Breaches of these Terms and Conditions</strong>
    </u>
    <p>Without prejudice to CSC’s other rights under these Terms and Conditions, if you breach the terms and conditions in any way,
        CSC may take such action as CSC deems appropriate to deal with the breach, including suspending your access to the Website,
        prohibiting you from accessing the Website, blocking computers using your IP address from accessing the Website, contacting
        your internet service provider to request that they block your access to the Website, and/or bringing legal proceedings
        against you.</p>
    <u>
        <strong>Termination</strong>
    </u>
    <p>You agree that CSC may, with or without cause, immediately terminate your account and access to the Website or the Services
        without prior notice. Without limiting the foregoing, the following will lead to a termination by CSC of a user 's use
        of the Website or the Services: (a) breaches or violations of these Terms and Conditions or other incorporated agreements
        or guidelines, (b) requests by law enforcement or other government agencies, (c) a request by you (self-initiated account
        deletions), (d) unexpected technical issues or problems, and (e) extended periods of inactivity. You agree that all terminations
        shall be made in CSC 's sole discretion and that CSC shall not be liable to you or any third-party for any termination
        of your account or access to the Website or the Services.</p>
    <u>
        <strong>Communications from CSC</strong>
    </u>
    <p>From time to time, CSC or other related entities will notify users of updates and other valuable information about CSC, the
        Website and related research information (see our Privacy Policy to learn more about communications). By using the Website,
        or registering or subscribing for services provided on or through the Website, users consent to being contacted by CSC
        and related entities, and to receiving such updates and information.</p>
    <u>
        <strong>Fees</strong>
    </u>
    <p>Signing up for an account is free. CSC reserves the right to charge for the Services or any portion thereof, modify the pricing
        of, add to, or discontinue the Services or any portion thereof without prior notice.</p>
    <u>
        <strong>Assignment</strong>
    </u>
    <p>CSC may transfer, sub-contract, or otherwise assign CSC’s rights and/or obligations under these Terms and Conditions without
        notifying you or obtaining your consent. You may not transfer, sub-contract, or otherwise deal with your rights and/or
        obligations under these Terms and Conditions.
    </p>
    <u>
        <strong>Governing Law</strong>
    </u>
    <p>Any disputes arising out of the use of the Website or the Services or these Terms and Conditions will be governed by the
        law of the State of Illinois, regardless of conflict of law principles. Sole and exclusive jurisdiction and venue over
        any dispute arising out of or relating to these Terms and Conditions shall lie in the appropriate federal or state court
        in Illinois.</p>
    <u>
        <strong>Statute of Limitations</strong>
    </u>
    <p>Any cause of action you may have with respect to use of the Website must be commenced within one (1) year after the claim
        or cause of action arises.</p>
    <u>
        <strong>Contacting My Tracker Coordinator</strong>
    </u>
    <p>For any questions or comments, or to report violations of these Terms and Conditions, let us know, or contact us at:</p>
    Cancer Support Community
    <br> Jeff Travers, Executive Vice President, Finance and Administration
    <br> 734 15th Street NW | Suite 300
    <br> Washington, DC 20005
    <br> 202-659-9709
    <br> jtravers@cancersupportcommunity.org
    <br>
    <br>
    <u>
        <strong>Headings and Severability</strong>
    </u>
    <p> The section titles of these Terms and Conditions are displayed for convenience only and have no legal effect. If any provision
        of these Terms and Conditions are found to be unenforceable for any reason, the remaining provisions will be unaffected
        and remain in full force and effect.</p>
    `
};
